import { Image, Text, View } from "@react-pdf/renderer";
import { useEffect, useState } from "react";
import { PropTypes } from 'prop-types';
import useLocales from '../../../hooks/useLocales';
import { dispatch } from "../../../redux/store";
import { getArticlesCO } from '../../../redux/slices/articles';
import noImage from '../../../assets/images/noImage.png';

ArticlePrintCO.propTypes = {
    coKey: PropTypes.string
};

export default function ArticlePrintCO({ coKey }) {

    const { currentLang } = useLocales();
    const [ src, setSrc ] = useState(undefined);
    const [ name, setName ] = useState("");

    useEffect(() => {
        if (coKey) {
            dispatch(getArticlesCO({ key: coKey, locale: currentLang.getValue })).then((response) => {
                setName(response.data.name);
                setSrc(response.data.thumbnail);
            });
        }
    }, [coKey, currentLang]);

    return (
      <View style={{ position: 'relative' }}>
        <Image src={noImage} />
        <Image
          src={src !== undefined ? `${process.env.REACT_APP_API_URL}/image/download/${src}?sizeIndex=0` : ''}
          style={{ position: 'absolute', top: '0px', left: '0px' }}
        />
        <Text style={{ textAlign: 'center', fontFamily: 'Lato' }}>{name}</Text>
      </View>
    );
}